export const PRIVATE_ASSET_MIME_TYPES = {
    IMAGE: ['image/jpeg', 'image/png', 'image/webp'],
    VIDEO: ['video/mp4', 'video/quicktime', 'video/webm'],
    AUDIO: ['audio/mpeg', 'audio/wav', 'audio/x-wav', 'audio/mp4', 'audio/x-m4a'],
    DOCUMENT: ['application/pdf'],
};
export const PRIVATE_MEDIA_ACCEPT = [
    ...PRIVATE_ASSET_MIME_TYPES.IMAGE,
    ...PRIVATE_ASSET_MIME_TYPES.VIDEO,
    ...PRIVATE_ASSET_MIME_TYPES.AUDIO,
].join(',');
//# sourceMappingURL=assets.js.map